module.exports = __webpack_public_path__ + "static/media/logo.a67ec5e0.svg";